import { SORT_DIRECTIONS } from '../constants';

export const isStatusOk = response => response.status === 200; // we need to modify this based on our real situation

export const formatDateForBackend = date =>
  date
    .split('-')
    .reverse()
    .join('-');

export const strToKebab = str => {
  const words = str.toLowerCase().split(/\s+/);
  return words.join('-');
};

export const redirectToUrl = (url, openInNewTab) => {
  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    window.location.replace(url);
  }
};

export const isEmptyString = str => {
  if (str.replace(/\s/g, '') === '') {
    return true;
  }
  return false;
};

export const maskMobileNumber = number => {
  if (number.length <= 4) {
    return number;
  }

  if (number.length <= 7) {
    return `${number.slice(0, 4)} ${number.slice(4, number.length)}`;
  }

  return `${number.slice(0, 4)} ${number.slice(4, 7)} ${number.slice(
    7,
    number.length,
  )}`;
};

export const maskLandLineNumber = number => {
  if (number.length <= 2) {
    return number;
  }

  if (number.length <= 6) {
    return `${number.slice(0, 2)} ${number.slice(2, number.length)}`;
  }

  return `${number.slice(0, 2)} ${number.slice(2, 6)} ${number.slice(
    6,
    number.length,
  )}`;
};

export const normalizePhoneNumber = value => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.startsWith('04')) {
    return maskMobileNumber(onlyNums);
  }

  return maskLandLineNumber(onlyNums);
};

export const normalizeMobileNumber = value => {
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(/[^\d]/g, '');

  return maskMobileNumber(onlyNums);
};

export const preparePhoneNumberForBackend = phoneNumber =>
  `+61${phoneNumber.replace(/^0/, '').replace(/\s/g, '')}`;

// export const preparePhoneNumberForFrontend = phoneNumber => {
//   // remove +61 and prepend 0
//   const formattedNumber = phoneNumber.replace(/^\+61/, '0');

//   // add spaces
//   if (formattedNumber.startsWith('04')) {
//     return `${formattedNumber.slice(0, 4)} ${formattedNumber.slice(
//       4,
//       7,
//     )} ${formattedNumber.slice(7, 10)}`;
//   }
//   return `${formattedNumber.slice(0, 2)} ${formattedNumber.slice(
//     2,
//     6,
//   )} ${formattedNumber.slice(6, 10)}`;
// };
export const preparePhoneNumberForFrontend = phoneNumber => {
  // remove +61 and prepend 0
  const formattedNumber = phoneNumber.replace(/^\+61/, '0');

  return formattedNumber;
  // add spaces
  // if (formattedNumber.startsWith('04')) {
  //   // eslint-disable-next-line prettier/prettier
  //   return `${formattedNumber.slice(0, 4)} ${formattedNumber.slice(
  //     4,
  //     7,
  //   )} ${formattedNumber.slice(7, 10)}`;
  // }
  // // eslint-disable-next-line prettier/prettier
  // return `${formattedNumber.slice(0, 2)} ${formattedNumber.slice(
  //   2,
  //   6,
  // )} ${formattedNumber.slice(6, 10)}`;
};

// format a string as 'Sentence case' (capitalize first word only).
export const sentenceCase = string =>
  string[0].toUpperCase() + string.slice(1).toLowerCase();

export const sortObjectByKey = (key, direction) => (a, b) => {
  const aVal = a[key];
  const bVal = b[key];

  switch (direction) {
    case SORT_DIRECTIONS.DESC:
      if (aVal > bVal) return -1;
      if (aVal < bVal) return 1;
      return 0;
    case SORT_DIRECTIONS.ASC:
    default:
      if (aVal > bVal) return 1;
      if (aVal < bVal) return -1;
      return 0;
  }
};

export const mapBusinessResponseToBusinessAttributes = res => ({
  businessNumber: res.businessNumber,
  businessName: res.name,
  businessPosition: res.position,
  businessMailingAddress: res.mailingAddress.fullAddress,
  businessDescription: res.description,
  businessPhoneNumber: res.phoneNumber,
  businessServiceAreaAddress: res.serviceArea.fullAddress,
  businessServiceAreaCoordinates: `${res.serviceArea.latitude}, ${res.serviceArea.longitude}`,
  businessServiceAreaType: res.serviceArea.type,
  businessSkillsetBuild: getSkillsetsByType(res.skillsets, 'build'),
  businessSkillsetLook: getSkillsetsByType(res.skillsets, 'look'),
  businessApproved: res.approved,
  businessServiceAreaState: res.serviceArea.state,
  materialLocation: res.materialLocation,
  logo: res.logo,
  coverPhoto: res.coverPhoto,
  gallery: res.gallery,
  googlePlaceId: res.googlePlaceId,
  googlePlaceField: res.googlePlaceField,
});

const getSkillsetsByType = (skillsets, type) => {
  const skills = skillsets
    .filter(skillset => skillset.type === type)
    .map(skillset => skillset.name);
  return skills && skills.length > 0 ? skills.join(' & ') : '';
};
